// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_4fQ","cls2":"CiterightLanding-cls2_F-6 CiterightLanding-cls1_4fQ"};